import { createTheme } from '@mui/material/styles';

// 1. Extend the theme palette types
declare module '@mui/material/styles' {
  interface PaletteColor {
    extraLight?: string;
    background?: string;
  }
  interface SimplePaletteColorOptions {
    extraLight?: string;
    background?: string;
  }
  interface Palette {
    pending?: Palette['primary'];
    sepia?: Palette['primary'];
  }
  interface PaletteOptions {
    pending?: PaletteOptions['primary'];
    sepia?: PaletteOptions['primary'];
  }

}

export const setAppTheme = (factor: any) => {
    
  const theme = createTheme({
  palette: {
      primary: {
        main: 'rgba(30, 78, 55, 1)',
        light: 'rgba(30, 78, 55, 0.80)',
        extraLight: 'rgba(101, 170, 136, 0.50)',
      },
      secondary: {
        main: 'rgba(247, 242, 221, 1)',
        light: 'rgba(247, 242, 221, 0.50)',
        extraLight: 'rgba(247, 242, 221, 0.20)',
      },
      pending: {
        main: 'rgba(183, 140, 49, 1)',
      },
      error: {
        main: 'rgba(204, 19, 19, 1)',
        light: 'rgba(204, 19, 19, 0.50)',
        extraLight: 'rgba(204, 19, 19, 0.20)',
      },
      sepia: {
        background: 'rgb(253, 252, 248)',
        extraLight: 'rgb(229, 215, 191)',
        light: 'rgb(189, 148, 98)',
        main: 'rgba(143, 92, 43, 1)',
        dark: 'rgba(85, 48, 14, 1)',
      },

    },
    typography: {
      fontFamily: 'Fredoka',

      h1: { fontSize: `${6 * factor}rem` },  // Original size is 6rem
      h2: { fontSize: `${3.75 * factor}rem` }, // Original size is 3.75rem
      h3: { fontSize: `${3 * factor}rem` },  // Original size is 3rem
      h4: { fontSize: `${2.125 * factor}rem` }, // Original size is 2.125rem
      h5: { fontSize: `${1.5 * factor}rem` },  // Original size is 1.5rem
      h6: { fontSize: `${1.25 * factor}rem` }, // Original size is 1.25rem
      subtitle1: { fontSize: `${1 * factor}rem` },  // Original size is 1rem
      subtitle2: { fontSize: `${0.875 * factor}rem` },  // Original size is 0.875rem
      body1: { fontSize: `${1 * factor}rem` },  // Original size is 1rem
      body2: { fontSize: `${0.875 * factor}rem` },  // Original size is 0.875rem
      button: { fontSize: `${0.875 * factor}rem` },  // Original size is 0.875rem
      caption: { fontSize: `${0.75 * factor}rem` },  // Original size is 0.75rem
      overline: { fontSize: `${0.75 * factor}rem` },  // Original size is 0.75rem
    },
  });

  return theme
}